import { FC, useEffect, useState } from "react";
import { Column, Row } from "../../containers";
import { DateRangeInputPopupProps } from "./types";
import { PopupClose } from "../../../popup";
import { usePopupStore, useThemeStore } from "../../../stores";
import DateInput from "../date-input";
import { Timestamp } from "../../../types";
import { JustifyContent } from "../../containers/types";
import { Button } from "../../buttons";

const DateRangeInputPopup: FC<DateRangeInputPopupProps> = ({
  range,
  setRange = () => {},
}) => {
  const theme = useThemeStore((s) => s.theme);
  const setPopupProperties = usePopupStore((s) => s.setPopupProperties);
  const setPopupBody = usePopupStore((s) => s.setPopupBody);

  useEffect(() => {
    setPopupProperties({
      style: {
        maxHeight: "80%",
        overflowY: "hidden",
        maxWidth: 430,
        minHeight: 450,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [fromDate, setFromDate] = useState<Timestamp>(range.from);
  const [toDate, setToDate] = useState<Timestamp>(range.to);

  const onSubmit = (): void => {
    setRange({ from: fromDate, to: toDate });
    setPopupBody(null);
  };

  return (
    <Column
      style={{
        position: "relative",
        padding: "2rem 1rem 1rem 1rem",
        minHeight: "inherit",
      }}
      gap={10}
      justifyContent={JustifyContent.Between}
    >
      <PopupClose />

      <div style={{ width: "100%" }}>
        <DateInput date={fromDate} label="از" setDate={setFromDate} />
        <DateInput date={toDate} label="تا" setDate={setToDate} />
      </div>

      <Row style={{ width: "100%" }} justifyContent={JustifyContent.End}>
        <Button
          onClick={onSubmit}
          background={theme.primary}
          color={theme.textOnprimary}
        >
          تایید
        </Button>
      </Row>
    </Column>
  );
};

export default DateRangeInputPopup;
